export default __webpack_public_path__ + "static/media/medicalanalyticstransparentbackground.08e98b14.png";